import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"
import { InputType } from "../../../components/TextInput/const/InputType.enum"

export default () => {
	const { t } = useTranslation("marketplaces", { keyPrefix: "dataTableHeaders.tips" })

	return columns(t)
}

const columns = (t: TFunction) => [
	{
		key: "id",
		title: t("id"),
		dataIndex: "id",
		sorteable: true,
		autoSort: false,
		width: "8%"
	},
	{
		title: t("user"),
		dataIndex: "user",
		key: "user",
		width: "20%"
	},
	{
		title: t("name"),
		dataIndex: "name",
		key: "name",
		width: "20%"
	},
	{
		title: t("description"),
		dataIndex: "description",
		key: "description",
		width: "37%"
	},
	{
		title: t("position"),
		dataIndex: "position",
		key: "position",
		inputType: InputType.NUMBER,
		sorteable: true,
		editable: true,
		width: "5%"
	},
	{
		title: "",
		key: "actions",
		dataIndex: "actions",
		width: "10%"
	}
]
